/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMemberDto } from '../../models/backend-member-dto';

export interface AccessProjectsMembersList$Params {
  project_id: number;
}

export function accessProjectsMembersList(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsMembersList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendMemberDto>>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsMembersList.PATH, 'get');
  if (params) {
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendMemberDto>>;
    }),
  );
}

accessProjectsMembersList.PATH = '/api/access/projects/{project_id}/members/';
